import { apiAddress } from '../ApiPlatform';

export const API_INSERT_NOTI = apiAddress + '/noti/insert';
export const API_SELECT_NOTI_LIST = apiAddress + '/noti/select';
export const API_SELECT_NOTI_LIST_FOR_CUSTOMER =
  apiAddress + '/noti/selectforCustomer';
export const API_UPDATE_NOTI = apiAddress + '/noti/update';

//export const API_UPDATE_FEES = apiAddress + '/common/feesUpdate';
